import {MenuOutlined, ZoomInOutlined} from '@ant-design/icons'
import {Button, Col, Form, Input, Layout, PageHeader, Row, Table, Tag} from 'antd'
import {ColumnsType} from 'antd/lib/table/interface'
import * as React from 'react'
import {useState} from 'react'
import {useQuery} from 'react-query'
import {renderRoutes, RouteConfigComponentProps} from 'react-router-config'
import {Link, useHistory} from 'react-router-dom'
import {useRecoilState} from 'recoil'
import {menuCollapseState} from '../../../state/atoms'
import {ROLES_SELECT_MP} from '../../constants'
import {qs} from '../../queries'
import {UserModel} from '../../typings'

const queryString = require('query-string')

const AdvancedSearchForm = React.memo(({ setQsQuery, refetch }: { setQsQuery: (data: any) => void, refetch: () => void }) => {
  const [filterForm] = Form.useForm()

  const onFinish = (values: any) => {
    let __qs = queryString.stringify(values, { arrayFormat: 'comma' })

    setQsQuery(__qs)
    setQsQuery(__qs)

    refetch()
  }

  return (
    <Form
      form={filterForm}
      name="advanced_search"
      className="advanced-search-form"
      onFinish={onFinish}
      layout={'vertical'}
    >
      <Row gutter={24}>
        <Col span={10}>
          <Form.Item name={'filter{name.icontains}'} label="Nome">
            <Input/>
          </Form.Item>
        </Col>
        <Col span={7}>
          <Form.Item name={'filter{cpf.icontains}'} label="CPF">
            <Input/>
          </Form.Item>
        </Col>
        <Col span={7}>
          <Form.Item name={`filter{phone.icontains}`} label="Telefone">
            <Input/>
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={24} style={{ textAlign: 'right' }}>
          <Button type="primary" htmlType="submit">
            Filtrar
          </Button>
          <Button
            style={{ margin: '0 8px' }}
            onClick={() => {
              filterForm.resetFields()
              setQsQuery('')
              setQsQuery('')
              refetch()
            }}
          >
            Resetar filtro
          </Button>
        </Col>
      </Row>
    </Form>
  )
})

type Props = RouteConfigComponentProps

export const TeamListPage: React.FC<Props> = (props) => {
  const [qs_query, setQsQuery] = useState('')
  const { isFetching, data, refetch } = useQuery('getUsers', () => qs.users.all(qs_query))
  const history = useHistory()
  const [collapsed, setCollapsed] = useRecoilState(menuCollapseState)

  const grid_columns: ColumnsType<UserModel> = [
    {
      title: 'Nome',
      width: 300,
      dataIndex: 'name'
    },
    {
      title: 'E-mail',
      width: 150,
      dataIndex: 'email'
    },
    {
      title: 'Telefone',
      width: 200,
      render: (record: UserModel) => {
        return <>
          Celular: {record.phone_mobile}
          <br/> Telefone: {record.phone}
        </>
      }
    },
    {
      title: 'Função',
      dataIndex: 'role',
      width: 80,
      render: (value) => <Tag>{ROLES_SELECT_MP[value]}</Tag>
    },
    {
      title: 'Ações',
      dataIndex: 'id',
      align: 'right',
      width: 20,
      render: (value) => (
        <Link to={`/team/${value}`}><ZoomInOutlined style={{ fontSize: '16px', marginRight: 5 }}/></Link>
      )
    }
  ]

  return (
    <React.Fragment>
      <PageHeader
        ghost={false}
        title={'Equipe'}
        onBack={() => setCollapsed(!collapsed)}
        backIcon={<MenuOutlined/>}
      />

      <AdvancedSearchForm refetch={refetch} setQsQuery={setQsQuery}/>

      <Layout.Content className="body-container">
        <Button type="primary" onClick={() => history.push('/team/new')}>Novo</Button>

        <Table columns={grid_columns} dataSource={data} rowKey="id" loading={isFetching}/>

        {renderRoutes(props.route?.routes)}
      </Layout.Content>
    </React.Fragment>
  )
}
